import React, { useEffect, useState } from 'react';
import ReactGA4 from 'react-ga4';
import { Col, Row } from 'reactstrap';

import SubscriptionBillingModalContainer from '../../containers/SignUpContainers/subscriptionBillingModalContainer';
import history from '../../utils/history';
import Banner from '../Banner/Banner';
import { Desktop } from '../Common/const';
import SignUpBenefits from './SignUpBenefits/SignUpBenefits';
import SignUpBibs from './SignUpBibs/SignUpBibs';
import SignUpMobileStep from './SignUpMobileStep/SignUpMobileStep';
import SignUpSidebar from './SignUpSidebar/SignUpSidebar';

function SignUpView(props) {
  const [state, setState] = useState({
    rate: { id: 0, name: '', isPfeOnly: false },
    rank: '',
    dutyState: 'Regular',
    selectedPlan: {},
    card: '',
    city: '',
    country: '',
    ccName: '',
    address: '',
    email: '',
    password: '',
    mobileStep: false,
    isModalOpen: false,
    freeTrial: true,
    bannerOpen: true,
    phoneNumber: '',
    countryCode: '',
    highestEducationLevel: '',
    currentEnrollmentStatus: '',
  });

  useEffect(() => {
    ReactGA4.send({ hitType: 'pageview', page: '/#/auth/signup' });
    props.loadAllPublicRates();
    props.loadPlans();
    if (props.subscriptionSuccess) {
      setState((prevState) => ({
        ...prevState,
        isModalOpen: false,
      }));
    }
  }, [props.subscriptionSuccess]);
  const makeSubscription = async (values = state) => {
    const cardData = {
      address_line1: values.address,
      address_city: values.city,
      address_state: values.state,
      address_country: values.country,
      name: values.ccName,
      address_zip: values.zip,
      tokenCard: values.tokenCard,
    };
    // eslint-disable-next-line
    let toSend = Object.assign({}, values);
    toSend = { ...state, ...values };

    // Check if all attributes of the card object are defined

    toSend.stripeToken = cardData.tokenCard;
    toSend.rate = toSend.rate.id;
    const fullName = toSend.ccName.split(' ');
    toSend.name = fullName.slice(0, -1).join(' ');
    toSend.lastName = fullName.slice(-1).join(' ');
    toSend.planId = toSend.selectedPlan.id;
    delete toSend.card;
    delete toSend.mobileStep;
    delete toSend.isModalOpen;
    props.makeSubscription(toSend);
  };

  const closeBanner = () => {
    setState((prev) => ({
      ...prev,
      bannerOpen: false,
    }));
  };

  const updateFormState = (states) => {
    setState((prev) => ({
      ...prev,
      ...states,
    }));
  };

  const openSubscriptionModal = (value) => {
    setState((prev) => ({
      ...prev,
      isModalOpen: value,
    }));
  };

  return (
    <>
      <Row className="signup-page mx-0">
        {!state.mobileStep && (
          <div className="banner-signup-exam">
            <Banner
              bannersActive={[
                {
                  description: `Promotion Wingman has your Weighted Airman Promotion System (WAPS) study materials!  It's time to study!`,
                },
              ]}
            />
          </div>
        )}
        <div
          className={
            !state.mobileStep
              ? 'signup-sidebar-container'
              : 'signup-sidebar-container d-none'
          }
        >
          <SignUpSidebar
            bannerOpen={state.bannerOpen}
            closeBanner={closeBanner}
            updateFormState={updateFormState}
            rates={props.rates}
            loadReferences={props.loadReferences}
            loadQualsData={props.loadQualsData}
            plans={props.plans}
            selectedPlan={state.selectedPlan}
            checkEmailExists={props.checkEmailExists}
            checkEmailExistsWaiting={props.checkEmailExistsWaiting}
            checkEmailExistsSuccess={props.checkEmailExistsSuccess}
            checkEmailExistsMessage={props.checkEmailExistsMessage}
            setCheckEmailExistsMessage={props.setCheckEmailExistsMessage}
            makeSubscription={makeSubscription}
            subscriptionWaiting={props.subscriptionWaiting}
            subscriptionSuccess={props.subscriptionSuccess}
            subscriptionMessage={props.subscriptionMessage}
            setSubscriptionMessage={props.setSubscriptionMessage}
            setSubscriptionWaiting={props.setSubscriptionWaiting}
            openSubscriptionModal={(value) => openSubscriptionModal(value)}
            loadingReferences={props.loadingReferences}
          />
        </div>
        {state.mobileStep && (
          <SignUpMobileStep
            OnSubmit={() => openSubscriptionModal(true)}
            OnBack={() => updateFormState({ mobileStep: false })}
            updateFormState={updateFormState}
            loadingReferences={props.loadingReferences}
          />
        )}
        <div className="signup-bibs-container">
          <SignUpBibs
            rate={state.rate}
            rank={state.rank}
            dutyState={state.dutyState}
            loadingReferences={props.loadingReferences}
            references={props.references}
            contentByWarfareQuals={props.contentByWarfareQuals}
            referencesPmk={props.referencesPmk}
            cycle={props.cycle}
            chaptersWithoutQuestions={props.chaptersWithoutQuestions}
            chaptersCount={props.chaptersCount}
            questionsOccupationalCounter={props.questionsOccupationalCounter}
            questionsPmkCounter={props.questionsPmkCounter}
            chaptersPmkCount={props.chaptersPmkCount}
            chaptersPmkWithoutQuestions={props.chaptersPmkWithoutQuestions}
            ratingExamQuestions={props.ratingExamQuestions}
          />
        </div>
        <div className="signup-benefits-container">
          <SignUpBenefits />
        </div>
        {state.isModalOpen && (
          <SubscriptionBillingModalContainer
            isOpen={state.isModalOpen}
            onClose={() => openSubscriptionModal(false)}
            selectedPlan={state.selectedPlan}
            rate={state.rate}
            plans={props.plans}
            onUpdate={(values) => updateFormState(values)}
            checkEmailExists={props.checkEmailExists}
            checkEmailExistsWaiting={props.checkEmailExistsWaiting}
            checkEmailExistsSuccess={props.checkEmailExistsSuccess}
            checkEmailExistsMessage={props.checkEmailExistsMessage}
            setCheckEmailExistsMessage={props.setCheckEmailExistsMessage}
            makeSubscription={makeSubscription}
            subscriptionWaiting={props.subscriptionWaiting}
            subscriptionSuccess={props.subscriptionSuccess}
            subscriptionMessage={props.subscriptionMessage}
            setSubscriptionMessage={props.setSubscriptionMessage}
            setSubscriptionWaiting={props.setSubscriptionWaiting}
            checkCoupon={props.checkCoupon}
            coupon={props.coupon}
            setCoupon={props.setCoupon}
            questionsOccupationalCounter={props.questionsOccupationalCounter}
          />
        )}
      </Row>
    </>
  );
}

export default SignUpView;
